import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { CreateBorderoBody, CreateReturnFileBody, CreateTitlesBorderoBody, CreateWithdrawnBody, GetAccountBalanceQueryParams, GetAccountsQueryParams, GetBorderoDetailQueryParams, GetBorderosQueryParams, GetLinkedAccountExtractQueryParams, GetStandbyTitlesQueryParams, GetTransferSummaryQueryParams, PostProcessCnabBody, PostProcessXmlBody, PostUploadFileParams, RequestLinkedTransferBody, StandByResponse } from "../../models/standby/standby-service.model";
import { Observable } from "rxjs";
import { LinkedAccountData } from "../../models/standby/linked-account";
import { LinkedAccountBalance } from "../../models/standby/linked-account-balance";
import { Withdrawn } from "../../models/standby/withdrawn";
import { CreateBorderoResponse, RejectedTitles, StandbyTitleData } from "../../models/standby/titles";
import { getApiUrl } from 'src/app/core/state/general-state/general.selectors';
import { Bordero, BorderoDetail } from "../../models/standby/bordero";
import { LinkedAccountExtract } from "src/app/models/standby/linked-account-extract";
import { Pendencies, TransferSummaryResponse } from "src/app/models/standby/transfer-summary";
import { StandbyProcessFileCnabResponse, StandbyProcessFileXmlResponse } from "src/app/models/standby/standby-files";
import { ReturnFileData, ReturnFilesLayout } from "src/app/models/standby/return-files";


@Injectable({
  providedIn: 'root'
})
export class StandbyService {

  // apiUrl: string = 'http://localhost:8080';
  apiUrl: string = '';

  constructor(
    private http: HttpClient,
    private store: Store
  ) {
    this.store.select(getApiUrl).subscribe(apiUrl => this.apiUrl = apiUrl);
  }

  getLinkedAccounts({ holderTaxId }: GetAccountsQueryParams): Observable<StandByResponse<LinkedAccountData[]>> {
    const url = '/v1/standby/api/v1/cadastros/cedente/conta-bmp';

    const params = new HttpParams()
      .set('CnpjCedente', holderTaxId)
      .set('idDB', '1')

    return this.http.get<StandByResponse<LinkedAccountData[]>>(`${this.apiUrl + url}`, { params })
  }

  getLinkedAccountBalance({ holderTaxId, account, accountDigit, accountType, agency, bank }: GetAccountBalanceQueryParams): Observable<StandByResponse<LinkedAccountBalance>> {
    const url = '/v1/standby/api/v1/servicos/bmp/saldo';

    const params = new HttpParams()
      .set('CnpjCedente', holderTaxId)
      .set('idDB', '1')

    if (account && accountDigit && accountType && agency && bank) {
      params
        .set('Banco', bank)
        .set('Agencia', agency)
        .set('Conta', account)
        .set('ContaDigito', accountDigit)
        .set('TipoConta', accountType)
    }

    return this.http.get<StandByResponse<LinkedAccountBalance>>(`${this.apiUrl + url}`, { params })
  }

  getWithdrawns(taxId?: string): Observable<StandByResponse<Withdrawn[]>> {
    const url = '/v1/standby/api/v1/aplicacao/sacado/listar'
    const params = new HttpParams()
      .set('idDB', '1')
      .set('CpfCnpj', taxId ?? '')


    return this.http.get<StandByResponse<Withdrawn[]>>(`${this.apiUrl + url}`, { params })
  }

  createWithdrawn(body: CreateWithdrawnBody) {
    const url = `/v1/standby/api/v1/aplicacao/sacado`;
    return this.http.post(`${this.apiUrl + url}`, body);
  }

  getTitles({
    baseDate,
    endDate,
    startDate,
    status,
    holderTaxId
  }: GetStandbyTitlesQueryParams, type: string): Observable<StandByResponse<StandbyTitleData>> {
    const url = `/v1/standby/api/v1/relatorio/operacionais/titulos/${type}/Analitico`
    let params; 
    
    if (type === 'aberto') {
      params = new HttpParams()
        .set('idDB', '1')
        .set('OrigemOperacoes', '1111111011011100')
        .set('DataBase', baseDate)
        .set('Status', String(status))
        .set('DataInicial', startDate)
        .set('DataFinal', endDate)
        .set('IdentificadorCedenteGrupo', holderTaxId)
        .set('TipoPeriodo', 'Operacao')
        .set('TipoCalculo', 'NaoCalcular')
        .set('TipoConsultaCedenteGrupo', 'Cnpj')
        .set('TipoImpressao', 'Analitico')
    } else {
      params = new HttpParams()
        .set('idDB', '1')
        .set('origemRelatorio', 'Relatorio')
        .set('cnpjCedente', holderTaxId)
        .set('origemOperacoes', '1111111011011100')
        .set('dataBase', baseDate)
        .set('tipoConsultaCedenteGrupo', 'Cnpj')
        .set('dataDe', 'Operacao')
        .set('tipoImpressao', 'Analitico')
        .set('dataInicial', startDate)
        .set('dataFinal', endDate)
        .set('dataInicialLiquidacao', startDate)
        .set('dataFinalLiquidacao', baseDate)
    }

    return this.http.get<StandByResponse<StandbyTitleData>>(`${this.apiUrl + url}`, { params })
  }

  getBorderos({ endDate, holderTaxId, startDate }: GetBorderosQueryParams): Observable<StandByResponse<Bordero[]>> {
    const url = '/v1/standby/api/v1/relatorio/operacionais/conferencia-bordero/listar';

    const params = new HttpParams()
      .set('idDB', '1')
      .set('DataInicial', startDate)
      .set('DataFinal', endDate)
      .set('CnpjCedente', holderTaxId)

    return this.http.get<StandByResponse<Bordero[]>>(`${this.apiUrl + url}`, { params })
  }

  getBorderoDetail({ bordero, official, sourceReport }: GetBorderoDetailQueryParams): Observable<StandByResponse<BorderoDetail>> {
    const url = '/v1/standby/api/v1/relatorio/operacionais/conferencia-bordero/detalhar';

    const params = new HttpParams()
      .set('idDB', '1')
      .set('Bordero', bordero)
      .set('Oficial', official)
      .set('OrigemRelatorio', sourceReport)

    return this.http.get<StandByResponse<BorderoDetail>>(`${this.apiUrl + url}`, { params })

  }

  getLinkedAccountExtract({ year, month, id, startDay, endDay }: GetLinkedAccountExtractQueryParams): Observable<StandByResponse<LinkedAccountExtract>> {

    const url = '/v1/standby/api/v1/servicos/bmp/extrato';

    const params = new HttpParams()
      .set('idDB', '1')
      .set('id', id)
      .set('Mes', month)
      .set('Ano', year)
      .set('DiaInicio', startDay)
      .set('DiaFim', endDay)

    return this.http.get<StandByResponse<LinkedAccountExtract>>(`${this.apiUrl + url}`, { params })
  }

  getTransferSummary({ endDate, holderTaxId, startDate }: GetTransferSummaryQueryParams): Observable<StandByResponse<TransferSummaryResponse>> {

    const url = '/v1/standby/api/v1/relatorio/operacionais/titulos/cedente';

    const params = new HttpParams()
      .set('idDB', '1')
      .set('cnpjCedente', holderTaxId)
      .set('enumRelatorio', 'Todos')
      .set('esconderTitulos', 'true')
      .set('dataEmissaoInicial', startDate)
      .set('dataEmissaoFinal', endDate)

    return this.http.get<StandByResponse<TransferSummaryResponse>>(`${this.apiUrl + url}`, { params })
  }

  getRejectedTitles({ endDate, holderTaxId, startDate }: GetTransferSummaryQueryParams): Observable<StandByResponse<RejectedTitles[]>> {
    const url = '/v1/standby/api/v1/aplicacao/titulos-rejeitados/listar'

    const params = new HttpParams()
      .set('idDB', '1')
      .set('origemRelatorio', 'Rejeitados')
      .set('cnpjCedente', holderTaxId)
      .set('dataInicial', startDate)
      .set('dataFinal', endDate)

    return this.http.get<StandByResponse<RejectedTitles[]>>(`${this.apiUrl + url}`, { params })
  }


  getPendencies({ endDate, holderTaxId, startDate }: GetTransferSummaryQueryParams): Observable<StandByResponse<Pendencies[]>> {
    const url = '/v1/standby/api/v1/relatorio/operacionais/pendencias'

    const params = new HttpParams()
      .set('idDB', '1')
      .set('situacao', 'Todas')
      .set('tipo', 'Debito')
      .set('datarPendencia', 'Inclusao')
      .set('datarLiquidadas', 'Baixa')
      .set('situacao', 'Todas')
      .set('CnpjCedente', holderTaxId)
      .set('dataInicial', startDate)
      .set('dataFinal', endDate)

    return this.http.get<StandByResponse<Pendencies[]>>(`${this.apiUrl + url}`, { params })
  }

  uploadFile({type, holderTaxId, body}: PostUploadFileParams): Observable<{success:boolean}> {
    const url = `/v1/standby/api/v1/file-manager/${type}/${holderTaxId}`
    return this.http.post<{success:boolean}>(`${this.apiUrl + url}`, body);
  }

  processCnab(body: PostProcessCnabBody): Observable<StandByResponse<StandbyProcessFileCnabResponse>> {
    const url = `/v1/standby/api/v1/simulacoes/importacao-operacao/cnab`;
    return this.http.post<StandByResponse<StandbyProcessFileCnabResponse>>(`${this.apiUrl + url}`, body);
  }

  processXml(body: PostProcessXmlBody): Observable<StandByResponse<StandbyProcessFileXmlResponse>> {
    const url = `/v1/standby/api/v1/simulacoes/importacao-operacao/xml`;
    return this.http.post<StandByResponse<StandbyProcessFileXmlResponse>>(`${this.apiUrl + url}`, body);
  }

  releaseBordero(borderoNumber: number) {
    const body = {
      idDB: "1",
      fieldsName: [
        "Situacao"
      ],
      data: {
        situacao: "IncompletoIrregular",
        numeroBordero: borderoNumber
      }
    }

    const url = `/v1/standby/api/v1/simulacoes/bordero-simulado`;
    return this.http.patch<StandByResponse<StandbyProcessFileCnabResponse>>(`${this.apiUrl + url}`, body);
  }

  createBordero(body: CreateBorderoBody): Observable<StandByResponse<CreateBorderoResponse>> {
    const url = `/v1/standby/api/v1/simulacoes/bordero-simulado`;
    return this.http.post<StandByResponse<CreateBorderoResponse>>(`${this.apiUrl + url}`, body);
  }

  createBorderoWithTitles(body: CreateTitlesBorderoBody) {
    const url = `/v1/standby/api/v1/simulacoes/titulo-simulado`;
    return this.http.post<StandByResponse<CreateBorderoResponse>>(`${this.apiUrl + url}`, body);
  }

  downloadPdfTitles(holderTaxId: string, withdrawnTaxId: string, titleNumber: string) {
    const url = `/v1/standby/fidc_homologa/cobranca/boleto/externo/pdf/${holderTaxId}/${withdrawnTaxId}/${titleNumber}`
    return this.http.get<any>(`${this.apiUrl + url}`,  {
      responseType: 'blob' as 'json'
    });
  }

  requestLinkedTransfer(body: RequestLinkedTransferBody) {
    const url = `/v1/standby/transfer/request`;
    return this.http.post(`${this.apiUrl + url}`, body)
  }

  getReturnFilesLayouts(holderTaxId: string): Observable<StandByResponse<ReturnFilesLayout[]>> {
    const url = `/v1/standby/api/v1/utilitarios/arquivos/retorno/layouts/1/${holderTaxId}`
    return this.http.get<StandByResponse<ReturnFilesLayout[]>>(`${this.apiUrl + url}`);
  }

  getReturnFiles(holderTaxId: string): Observable<StandByResponse<string[]>> {
    const url = `/v1/standby/api/v1/utilitarios/arquivos/retorno/1/${holderTaxId}`
    return this.http.get<StandByResponse<string[]>>(`${this.apiUrl + url}`);
  }

  getReturnFileByName(holderTaxId: string, fileName: string): Observable<StandByResponse<ReturnFileData>> {
    const url = `/v1/standby/api/v1/utilitarios/arquivos/retorno/1/${holderTaxId}/${fileName}`
    return this.http.get<StandByResponse<ReturnFileData>>(`${this.apiUrl + url}`);
  }

  createReturnFile(body: CreateReturnFileBody) {
    const url = `/v1/standby/api/v1/utilitarios/arquivos/retorno`;
    return this.http.post(`${this.apiUrl + url}`, body)
  }

  deleteReturnFile(holderTaxId: string, fileName: string) {
    const url = `/v1/standby/api/v1/utilitarios/arquivos/retorno/1/${holderTaxId}/${fileName}`
    return this.http.delete<any>(`${this.apiUrl + url}`);
  }
}